// extracted by mini-css-extract-plugin
export default {"wrapper":"FeelAddItem_wrapper__LsT3Z","skeletonBlockOne":"FeelAddItem_skeletonBlockOne__CIOwY","skeletonBlockTwo":"FeelAddItem_skeletonBlockTwo__dd4ZN"};